
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class TestGroupDialog extends SiteEntityDialog<TestGroupRow, any> {
        protected getFormKey() { return TestGroupForm.formKey; }
        protected getIdProperty() { return TestGroupRow.idProperty; }
        protected getLocalTextPrefix() { return TestGroupRow.localTextPrefix; }
        protected getNameProperty() { return TestGroupRow.nameProperty; }
        protected getService() { return TestGroupService.baseUrl; }

        protected form = new TestGroupForm(this.idPrefix);

        protected onSaveSuccess(response: Serenity.SaveResponse) {
            super.onSaveSuccess(response);
            Q.reloadLookup('Distinct.Data.TestGroupTest.ParameterBinding');
        }
        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            var that = this;
            // Remove default clone button and override behavior
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "clone-button"), 1);

            buttons.push({
                title: 'Clone',
                cssClass: 'clone-button',
                icon: 'fa-copy',
                onClick: () => {

                    var cloneEntity = this.getCloningEntity();
                  
                    cloneEntity.TestList.forEach(that.removeVersion);
                    Serenity.Widget.create({
                        type: Q.getInstanceType(this),
                        init: w => Serenity.SubDialogHelper.bubbleDataChange(Serenity.SubDialogHelper.cascade(w, this.element), this, true).loadEntityAndOpenDialog(cloneEntity, false)
                    });
                }
            });
            return buttons;
        }

        protected removeVersion(item) {
            item.Version = null;
            item.CreatedBy = null;
            item.CreatedWhen = null;
            item.UpdatedBy = null;
            item.UpdatedWhen = null;

        }
    }
}